/* eslint-disable react/prop-types */
import React, { forwardRef, ForwardRefRenderFunction, ReactNode } from 'react';

const InnerKeyDownListener: KeyDownListenerForwardedRef = (
  { keys, children, onKeyDown },
  ref,
) => {
  return (
    <div
      ref={ref}
      tabIndex={-1}
      onKeyDown={(e) => {
        if (keys.includes(e.key)) {
          e.preventDefault();
          onKeyDown(e.key);
        }
      }}
    >
      {children}
    </div>
  );
};

export const KeyDownListener = forwardRef(InnerKeyDownListener);

type KeyDownListenerForwardedRef = ForwardRefRenderFunction<
  HTMLDivElement,
  KeyDownListenerProps
>;
export interface KeyDownListenerProps {
  keys: string[];
  children?: ReactNode;
  onKeyDown: (key: string) => void;
}
